import { Pipe, PipeTransform } from '@angular/core';
import {StringUtils} from "../utils/string-utils";

@Pipe({
    name: 'highlight',
    standalone: false
})
export class HighlightPipe implements PipeTransform {

  /**
   * Add <mark> tag around searched pattern
   * @param value
   * @param searchPattern
   * @param ignoreAccent
   */
  transform(value: string, searchPattern: string, ignoreAccent?: boolean): string {
    if (!value) {
      return '';
    }
    if (!searchPattern) {
      return value;
    }

    let regExGivenPattern;
    let matchedValue;

    if (ignoreAccent) {
      regExGivenPattern = new RegExp(`(${StringUtils.unaccent(searchPattern)})`, 'gi');
      matchedValue = StringUtils.unaccent(value);

      if (matchedValue.match(regExGivenPattern)) {
        const matchedValues = regExGivenPattern.exec(matchedValue);
        if (matchedValues) {
          const replacedValue = value.substring(0, matchedValues.index)
            + '<mark>' + value.substring(matchedValues.index, matchedValues.index+searchPattern.length) + '</mark>'
            + value.substring(matchedValues.index + searchPattern.length);

          return replacedValue;
        } else {
          return value;
        }

      } else {
        return value;
      }
    } else {
      regExGivenPattern = new RegExp(`(${searchPattern})`, 'gi');

      if (value.match(regExGivenPattern)) {
        return value.replace(regExGivenPattern, '<mark>$&</mark>');
      } else {
        return value;
      }
    }
  }

}
